module.exports = __webpack_public_path__ + "img/afterburn.e2a31b5d.svg";